import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { ADD, EDIT, globalData, VIEW } from '../../../../common/common';
import WEditor from 'wangeditor';

const Root = styled(Box)({
    width: '100%',
    height: '430px',
    padding: '0 10px',
    overflowY: 'scroll',
    '& .textWapper': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textWapperF': {
        width: '100%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .text': {
        width: '100%',
        height: '100%'
    },
    '& .wdWapper': {
        width: '100%',
        margin: '20px 0',
    },
})

class InputRichText extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return (
            <Root ref={(el) => { this.messagesEnd = el; }}>
                <div className="wdWapper">
                    <div id="wd"></div>
                </div>
            </Root>
        )
    }
    componentDidMount() {
        const { data } = this.props;
        this.wd = new WEditor("#wd");
        this.wd.customConfig.lang = {
            '设置标题': 'title',
            '正文': 'p',
            '链接文字': 'link text',
            '链接': 'link',
            '上传图片': 'upload image',
            '上传': 'upload',
            '创建': 'init',
            '背景色': 'background color',
            '文字颜色': 'text color',
            '字号': 'font size',
            '字体': 'font',
            '宋体': 'SimSun',
            '微软雅黑': 'Microsoft YaHei',
            '设置列表': 'setting list',
            '有序列表': 'numbered list',
            '无序列表': 'unordered list',
            '对齐方式': 'alignment',
            '靠左': 'left',
            '居中': 'center',
            '靠右': 'right',
            '默认': 'default',
            '新浪': 'sina',
            '网络图片': 'web image',
            '图片Link': 'image link',
            '插入表格': 'insert table',
            '行': 'row',
            '列': 'column',
            '的表格': ' table',
            '插入视频': 'insert video',
            '格式如：': 'format: ',
            '插入代码': 'insert code',
            '插入': 'insert',
        };
        this.wd.customConfig.onchange = html => {
            this.props.setToAllData("D.T", html);
        };
        this.wd.create();
        this.wd.txt.html(data ? data : '');
    }
    doNext() {
        const value = this.wd.txt.text();
        if (value) {
            return true;
        } else {
            globalData.toastMsg = "Please fill in the information";
            return false;
        }
    }
    getData() {
        return this.wd.txt.html();
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default InputRichText;